import React, { FC } from "react";
import { Table } from "antd";
import { useTranslation } from "react-i18next";
import { useGetPermissionsAndRolesColumns } from "shared/hooks/useGetPermissionsAndRolesColumns";
import { AddNewRole } from "shared/api";
import { useFormikContext } from "formik";
import { RenderClearFiltersButton } from "shared/ui";

interface PermissionsAndRolesTableProps {
  showEditRolesModal: () => void;
  rolesList: AddNewRole[] | undefined;
  filterByName: {
    value: string;
    onChange: (e: string | React.ChangeEvent<HTMLInputElement>) => void;
    onClear: () => void;
  };
  filterByPermission: {
    treeData: any;
    value: string[];
    onChange: React.Dispatch<React.SetStateAction<string[]>>;
    onClear: () => void;
  };
}

const PermissionsAndRolesTable: FC<PermissionsAndRolesTableProps> = ({
  showEditRolesModal,
  rolesList,
  filterByName,
  filterByPermission,
}) => {
  const { t } = useTranslation();

  const { setValues } = useFormikContext<AddNewRole>();

  const editRolesHandler = (record: AddNewRole) => {
    showEditRolesModal();
    setValues({
      id: record.id,
      name: record.name,
      permission_blocks: record.permission_blocks,
    });
  };

  const columns = useGetPermissionsAndRolesColumns({
    t,
    editRolesHandler,
    filterByName,
    filterByPermission,
  });

  const isVisibleClearFiltersButton = !!filterByName.value;

  return (
    <>
      {isVisibleClearFiltersButton && (
        <RenderClearFiltersButton
          onClick={() => {
            filterByName.onClear();
            filterByPermission.onClear();
          }}
        />
      )}

      <Table
        columns={columns}
        dataSource={rolesList}
        rowKey={(record) => record.name}
        pagination={false}
      />
    </>
  );
};

export { PermissionsAndRolesTable };
